import { render, staticRenderFns } from "./QuickDeclareStep3.vue?vue&type=template&id=6f369026&scoped=true&"
import script from "./QuickDeclareStep3.vue?vue&type=script&lang=js&"
export * from "./QuickDeclareStep3.vue?vue&type=script&lang=js&"
import style0 from "./QuickDeclareStep3.vue?vue&type=style&index=0&id=6f369026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f369026",
  null
  
)

export default component.exports